import urlResolver from 'admin/utils/URLResolver';
import { TaskItemResponse } from 'edrolo/domains/coursePortal/types/Task';
import { post } from 'edrolo/domains/net';
import useSWR from 'swr';

export const useStudentResponses = (taskId: number) => {
  const url = urlResolver.reverse('api:student_tasks-item-responses', {
    taskId,
  });
  const { data, error, isLoading, mutate } = useSWR<TaskItemResponse[]>(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  if (error) {
    console.error(error);
  }

  const __mergeNewResponseIntoExistingData = (
    newResponse: Partial<TaskItemResponse>
  ): TaskItemResponse[] => {
    if (!data) {
      return [];
    }

    return data.map((response) => {
      if (
        response.task_item === newResponse.task_item &&
        response.task_assignment === newResponse.task_assignment &&
        response.profile === newResponse.profile
      ) {
        return { ...response, ...newResponse };
      } else {
        return response;
      }
    });
  };

  const create = async (payload: Partial<TaskItemResponse>) => {
    const options = {
      optimisticData: __mergeNewResponseIntoExistingData(payload),
      rollbackOnError: true,
      revalidate: true,
    };

    try {
      await mutate(async () => {
        const response = await post(url, payload);
        return __mergeNewResponseIntoExistingData(response.body.toJS());
      }, options);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    data,
    isLoading,
    error,
    create,
    mutate,
  };
};
